import { useState, useEffect } from 'react'
import { useAppState } from '../Context'
import { IconPhone, IconEnvelope, IconMapPin } from './icons'

function LocationCard({ className, location, asInfoWindow = false, onClick = null }) {
  const [isSelected, setIsSelected] = useState(false)
  const { selectedLocation } = useAppState()

  useEffect(() => {
    setIsSelected(selectedLocation === location)
  }, [selectedLocation])

  return (
    <div
      data-id={location.id}
      className={`flex items-start justify-between text-sm xl:text-base ${className} ${
        isSelected ? 'location--selected' : ''
      }`}
    >
      <address className="relative font-normal">
        {asInfoWindow ? (
          <div className="lg:text-base text-primary">{location.displayName}</div>
        ) : (
          <div
            className="transition-colors cursor-pointer lg:text-base xl:text-lg text-primary hover:text-green"
            onClick={onClick}
          >
            {location.title}
          </div>
        )}
        {location.address1}
        {location.address2 && `, ${location.address2}`}
        <br />
        {location.city}, {location.state} {location.zip}
        <div className="mt-4">
          <a
            href={location.detailsUrl}
            className="inline-flex items-center text-secondary-hover"
            target={location.detailsUrlNewWindow ? '_blank' : '_self'}
          >
            <span>View Office Page</span>

            <svg viewBox="0 0 13 13" className="flex-shrink-0 ml-2 w-[14px]">
              <path
                d="M8 6.49a.798.798 0 0 0-.212-.538L4.258 2.23a.71.71 0 0 0-1.041-.003.807.807 0 0 0-.002 1.098L6.224 6.5l-3.01 3.176a.806.806 0 0 0-.19.75.757.757 0 0 0 .522.548.71.71 0 0 0 .711-.203l3.53-3.723A.799.799 0 0 0 8 6.49Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </address>

      <ul className="relative top-1 pl-4 space-y-3">
        {location.phone1 && (
          <li className="leading-none">
            <a className="inline-flex items-center whitespace-nowrap text-secondary-hover" href={location.phone1Url}>
              <IconPhone className="flex-shrink-0 mr-2 w-3 md:w-4" />
              <span>{location.phone1}</span>
            </a>
          </li>
        )}
        {location.phone2 && (
          <li className="leading-none">
            <a className="inline-flex items-center whitespace-nowrap text-secondary-hover" href={location.phone2Url}>
              <IconPhone className="flex-shrink-0 mr-2 w-3 md:w-4" />
              <span>{location.phone2}</span>
            </a>
          </li>
        )}
        {location.email && (
          <li className="leading-none">
            <a
              className="inline-flex items-center whitespace-nowrap text-secondary-hover"
              href={`mailto:${location.email}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconEnvelope className="flex-shrink-0 mr-2 w-3 md:w-4" />
              <span>Email Office</span>
            </a>
          </li>
        )}
        {location.directionsUrl && (
          <li className="leading-none">
            <a
              className="inline-flex items-center whitespace-nowrap text-secondary-hover"
              href={location.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconMapPin className="flex-shrink-0 mr-2 w-3 md:w-4" />
              <span>Get Directions</span>
            </a>
          </li>
        )}
      </ul>
    </div>
  )
}

export default LocationCard
